import { snackbar } from '@occc-app/design-system';
import { CampaignComponentTabs } from '@occc-app/routes/CampaignComponents/components/ConfigurationLayout';
import copies from '@occc-app/routes/CampaignComponents/copies';
import { Flow_Types, FormContainerProps } from '@occc-app/offerHelpers/types';
import { useConfig } from '@occc/config';

import { TargetForm } from './TargetForm';
import { useGetTargetFormProps } from './hooks';
import { TargetTabProps, GetTargetTabProps } from './types';

export type TargetFormContainerProps = FormContainerProps & {
  targetTabProps?: TargetTabProps | GetTargetTabProps;
  isDesignTabHidden?: boolean;
};

export const TargetFormContainer = ({
  offer,
  type,
  offerId,
  onRefetchOffer,
  isRefetching,
  setTabValue,
  onCancel,
  onError,
  offerLoading,
  currentFlowType,
  targetTabProps,
  isDesignTabHidden = false,
}: TargetFormContainerProps) => {
  const { config } = useConfig();

  const nextTab = isDesignTabHidden ? CampaignComponentTabs.Schedule : CampaignComponentTabs.Design;

  const onFormSubmitted = async () => {
    await onRefetchOffer();

    snackbar.success(copies.onSubmitSuccessToastMessage);

    if (currentFlowType === Flow_Types.Configure) {
      setTabValue(nextTab);
    }
  };

  const onNextStepButtonClick = () => {
    setTabValue(nextTab);
  };

  const targetFormProps = useGetTargetFormProps({
    offer,
    type,
    offerId,
    onCancel,
    onError,
    offerLoading,
    currentFlowType,
    onFormSubmitted,
    targetTabProps,
    onRefetchOffer,
    isRefetching,
  });

  const { shouldShowSubBrands: shouldTargetShowSubBrands = true } = targetFormProps;

  const shouldShowSubBrands = !!config.subBrands?.enabled && shouldTargetShowSubBrands;

  return (
    <TargetForm
      {...targetFormProps}
      onNextStepButtonClick={onNextStepButtonClick}
      shouldShowSubBrands={shouldShowSubBrands}
    />
  );
};
